import React, { Suspense, useEffect, useState } from "react";
import "./App.css";
import { Footer, NavPage, ScrollTop } from "./Layouts/index";
import { BrowserRouter } from "react-router-dom";
import { Loading } from "./components/index";
import axios from "axios";
import Cookies from "js-cookie";
import faviconLogo from "./assets/images/gold-logo.png";
import { toast } from "react-toastify";
import styles from "./Pages/Home/Home.module.css";
import { AppRoutes, PortalRoutes } from "./app/router";

function App() {
  const [loading, setLoading] = useState(true);
  const url = "https://whatsapptest.inter-netsys.com";
  const apiMethod = "/api/method/geniusapi.www.api";
  const limit = 8;
  // const pageUrl = window.location.pathname;
  // const lastWordIndex = pageUrl.lastIndexOf("/") + 1;
  // let pageName = pageUrl.substr(lastWordIndex);

  const pageUrl = window.location.pathname;
  const lastWordIndex = pageUrl.lastIndexOf("/") + 1;
  const pathParts = pageUrl.split("/").filter(Boolean);
  const requiresPageData =
    ["", "/", "/home"].includes(pageUrl) ||
    ["products", "categories", "about", "privacy"].includes(pathParts[0] || "home");

  let pageName = pathParts[0] || "home";
  let parentGroup =
    pathParts.length > 1 ? decodeURIComponent(pathParts[1]) : null;

  const [navbarData, setNavbarData] = useState([]);
  const [footerData, setFooterData] = useState({});
  const [logos, setLogos] = useState({});
  const [resultData, setResultData] = useState({});
  const [page_title, setPageTitle] = useState();
  const [data, setData] = useState([]);
  const [products, setProducts] = useState([]);
  const [reviews, setReviews] = useState([]);
  const [contentData, setContentData] = useState({});
  const [ItemData, setItemData] = useState({});
  const [CategoryData, setCategoryData] = useState({});

  const [innerPageData, setInnerPageData] = useState({});
  const [translationsData, setTranslationsData] = useState({});
  const [seoSettingsData, setSeoSettingsData] = useState({});
  const [language, setLanguage] = useState(
    Cookies.get("preferred_language") ?? "en",
  );
  const [translations, setTranslations] = useState(
    localStorage.getItem("translations")
      ? JSON.parse(localStorage.getItem("translations"))
      : {},
  );

  const fetchTranslations = async (lang) => {
    try {
      const response = await fetch(
        `${url}/api/method/geniusapi.www.api.get_translation_file?lang=${lang}`,
      );

      if (!response.ok) {
        toast.error(`HTTP error! status: ${response.status}`);
        return;
      }

      const data = await response.json();
      setTranslations(data);
      localStorage.setItem("translations", JSON.stringify(data));
    } catch (error) {
      console.error(`Error fetching translations: ${error}`);
    }
  };

  const changeLang = async (lang) => {
    try {
      const response = await axios.post(
        `${url}/api/method/geniusapi.www.api.set_language?name=${lang}`,
      );
      if (response.data && response.data.message === "Success") {
        Cookies.set("preferred_language", lang);
        setLanguage(lang);
        await fetchTranslations(lang);
      } else {
        toast.error("Failed to change language");
      }
    } catch (error) {
      console.error(`Error changing language: ${error}`);
    }
  };

  //   useEffect(() => {
  //     changeLang(language);
  //     const preferredLanguage = Cookies.get("preferred_language");
  //     if (language !== preferredLanguage) {
  //         fetchWebsiteData(pageName);
  //     }
  // }, [language]);

  useEffect(() => {
    const preferredLanguage = Cookies.get("preferred_language");
    if (preferredLanguage !== language) {
      changeLang(language);
      return;
    }

    if (!translations?.result) {
      fetchTranslations(language);
    }
  }, [language, translations?.result]);

  useEffect(() => {
    if (requiresPageData) {
      fetchWebsiteData(pageName);
      return;
    }

    setLoading(false);
  }, [language, pageName, requiresPageData]);

  const clearCookies = (clearLang = false) => {
    const cookies = document.cookie.split(";");
    for (let cookie of cookies) {
      const eqPos = cookie.indexOf("=");
      const name = eqPos > -1 ? cookie.substr(0, eqPos).trim() : cookie.trim();

      // Skip clearing the 'preferred_language' cookie if clearLang is false
      if (name === "preferred_language" && !clearLang) {
        continue;
      }
      //todo if cookie is expired
      // localStorage.clear();
      // Clear the cookie by setting its expiration date in the past
      document.cookie =
        name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/";
    }
  };

  const fetchWebsiteData = async (pageName) => {
    setLoading(true);
    const apiKey = Cookies.get("api_key");
    const apiSecret = Cookies.get("api_secret");
    try {
      let apiUrl = `${url}/api/method/geniusapi.genius_api.doctype.pages.pages.page?name=${pageName}`;

      if (pageName === "categories" && parentGroup) {
        apiUrl += `&parent_groups=${encodeURIComponent(parentGroup)}`;
      }

      const response = await axios.get(apiUrl);
      setData(
        pageName === "products" ||
          pageName === "categories" ||
          pageName === "category"
          ? response?.data?.result
          : response?.data?.result?.content || [],
      );
      setProducts(response?.data?.result?.content?.products || []);
      setReviews(response?.data?.result?.content?.reviews || []);
      setPageTitle(response?.data?.result?.page_title || "");
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    const appendHeadLink = (rel, href, options = {}) => {
      const selector = `link[rel="${rel}"][href="${href}"]`;
      let link = document.querySelector(selector);

      if (!link) {
        link = document.createElement("link");
        link.rel = rel;
        link.href = href;
        Object.assign(link, options);
        document.head.appendChild(link);
      }
    };

    appendHeadLink("preconnect", url, { crossOrigin: "" });
    appendHeadLink("dns-prefetch", url);
  }, [url]);

  useEffect(() => {
    const updateFavicon = () => {
      const link =
        document.querySelector('link[rel="icon"]') ||
        document.createElement("link");
      link.type = "image/x-icon";
      link.rel = "icon";
      link.href = `${logos?.logo_favicon || faviconLogo}`;
      document.head.appendChild(link);
    };

    const updateTitle = () => {
      const mainTitle = `${seoSettingsData?.main_title || ""} ${
        seoSettingsData?.separator || ""
      } ${innerPageData?.name || ""}`;
      const formattedTitle = mainTitle.trim() || "Genius";
      if (formattedTitle === undefined) document.title = "Genius";
      else {
        document.title = formattedTitle;
      }
    };

    updateFavicon();
    updateTitle();
  }, [logos, pageName, seoSettingsData, innerPageData]);

  const isPortalRoute = window.location.pathname === "/portal";

  if (isPortalRoute) {
    return (
      <div className="App">
        <BrowserRouter>
          <Suspense fallback={<Loading />}>
            <PortalRoutes />
          </Suspense>
        </BrowserRouter>
      </div>
    );
  }
  // className={`App ${language === "ar" ? "rtl" : "ltr"}`}
  return (
    <div className={`App ${language === "ar" ? "rtl" : "ltr"}`}>
      <BrowserRouter>
        {loading ? (
          <div>
            <NavPage
              url={url}
              translations={translations}
              language={language}
              setLanguage={setLanguage}
            />
            <Loading></Loading>
            <Footer translations={translations} />
          </div>
        ) : (
          <>
            <ScrollTop />
            <NavPage
              url={url}
              translations={translations}
              language={language}
              setLanguage={setLanguage}
            />
            <Suspense fallback={<Loading />}>
              <AppRoutes
                data={data}
                products={products}
                contentData={contentData}
                innerPageData={innerPageData}
                itemData={ItemData}
                categoryData={CategoryData}
                url={url}
                apiMethod={apiMethod}
                translations={translations}
                language={language}
                limit={limit}
                serviceId={pageUrl.substr(lastWordIndex)}
              />
            </Suspense>
            <Footer translations={translations} />
          </>
        )}
      </BrowserRouter>
      {/* WhatsApp Floating Button */}
      <a
        href="https://wa.me/YOUR_PHONE_NUMBER"
        className={styles.whatsapp_float}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Contact us on WhatsApp"
      >
        <svg className={styles.whatsapp_icon} xmlns="http://www.w3.org/2000/svg" fill="#fff"  viewBox="0 0 32 32" version="1.1">
          <title>whatsapp</title>
          <path d="M26.576 5.363c-2.69-2.69-6.406-4.354-10.511-4.354-8.209 0-14.865 6.655-14.865 14.865 0 2.732 0.737 5.291 2.022 7.491l-0.038-0.070-2.109 7.702 7.879-2.067c2.051 1.139 4.498 1.809 7.102 1.809h0.006c8.209-0.003 14.862-6.659 14.862-14.868 0-4.103-1.662-7.817-4.349-10.507l0 0zM16.062 28.228h-0.005c-0 0-0.001 0-0.001 0-2.319 0-4.489-0.64-6.342-1.753l0.056 0.031-0.451-0.267-4.675 1.227 1.247-4.559-0.294-0.467c-1.185-1.862-1.889-4.131-1.889-6.565 0-6.822 5.531-12.353 12.353-12.353s12.353 5.531 12.353 12.353c0 6.822-5.53 12.353-12.353 12.353h-0zM22.838 18.977c-0.371-0.186-2.197-1.083-2.537-1.208-0.341-0.124-0.589-0.185-0.837 0.187-0.246 0.371-0.958 1.207-1.175 1.455-0.216 0.249-0.434 0.279-0.805 0.094-1.15-0.466-2.138-1.087-2.997-1.852l0.010 0.009c-0.799-0.74-1.484-1.587-2.037-2.521l-0.028-0.052c-0.216-0.371-0.023-0.572 0.162-0.757 0.167-0.166 0.372-0.434 0.557-0.65 0.146-0.179 0.271-0.384 0.366-0.604l0.006-0.017c0.043-0.087 0.068-0.188 0.068-0.296 0-0.131-0.037-0.253-0.101-0.357l0.002 0.003c-0.094-0.186-0.836-2.014-1.145-2.758-0.302-0.724-0.609-0.625-0.836-0.637-0.216-0.010-0.464-0.012-0.712-0.012-0.395 0.010-0.746 0.188-0.988 0.463l-0.001 0.002c-0.802 0.761-1.3 1.834-1.3 3.023 0 0.026 0 0.053 0.001 0.079l-0-0.004c0.131 1.467 0.681 2.784 1.527 3.857l-0.012-0.015c1.604 2.379 3.742 4.282 6.251 5.564l0.094 0.043c0.548 0.248 1.25 0.513 1.968 0.74l0.149 0.041c0.442 0.14 0.951 0.221 1.479 0.221 0.303 0 0.601-0.027 0.889-0.078l-0.031 0.004c1.069-0.223 1.956-0.868 2.497-1.749l0.009-0.017c0.165-0.366 0.261-0.793 0.261-1.242 0-0.185-0.016-0.366-0.047-0.542l0.003 0.019c-0.092-0.155-0.34-0.247-0.712-0.434z"/>
        </svg>
      </a>
    </div>
  );
}

export default App;
